// import React from 'react'
import { useContext, useEffect, useState } from "react";
import TDDEECalculator from "../../components/TDDECalculator";
import MealplanPopupData from "../../components/_clients/LargePopup/mealplanPopupData";
import Icon from "../../components/_default/Icon";
import SearchPage from "../../components/_default/SearchPage";
import "./ToolBox.scss";
import Select from "react-select";
import UserContext from "../../services/context/userContext";
import { getClients } from "../../services/firebase/firestore/getData";
import Loading from "../../components/_default/Loading";
import { BsCalculator } from "react-icons/bs";
import RepetitionMeximumCalculator from "../../components/RepetitionMeximumCalculator";
import StrengthRatioCalculator from "../../components/StrengthRatioCalculator";
import UpdatedTDDE from "../../components/TDDECalculator/UpdatedTDDE";
import TestCalc from "../../components/TDDECalculator/TestCalc";
import aurumLogo from "../../assets/images/aurum.png"

function ToolBox() {
  let [tabSelected, setTabSelected] = useState("TDEE & Macro Calculator");
  let [selectClient, setSelectClient] = useState(false);
  let user = useContext(UserContext);
  let [options, setOptions] = useState([]);
  let [selectedClient, setSelectedClient] = useState({});
  let [loading, setLoading] = useState(true);
  let [toggleClient, setToggleClient] = useState(false);
  const [clientData, setClientData] = useState({});
  const [isclientChange,setIsClientChange]=useState(false)
  const client_pages = [
    { name: "TDEE & Macro Calculator" },
    { name: "% RM Calculator" },
    { name: "Strength Ratios" },
  ];
  useEffect(() => {
    getClients(user.id, (res) => {
      setOptions(res);
      setLoading(false);
      console.log("get clients", res);
    });
  }, []);
  useEffect(() => {
    // debugger
    // console.log("seleccted client", selectClient);
    let filterSeletedClient = options.filter(
      (data) => data.first_name + " " + data.last_name == selectClient
    );
    let filterClientObj = filterSeletedClient[0];
    setSelectedClient({ ...selectedClient, ...filterClientObj });
    // setIsClientChange(true)
    // // setSelectedClient(filterClientObj)
    // console.log("selected client", selectedClient);
  // }, [selectClient]);
  if(isclientChange==false){
    setTimeout(()=>{

      setIsClientChange(true)
    },1000)
  }
  }, [isclientChange]);
  
  const handleSelectClient = (e) => {
    debugger;
    // console.log("select client", e.label);
    setSelectClient(e.label);
    setToggleClient(true);
    let filterSeletedClient = options.filter(
      (data) => data.first_name + " " + data.last_name == e.label
    );
    let filterClientObj = filterSeletedClient[0];
    // setSelectedClient({...selectedClient,...filterClientObj})
    setSelectedClient(filterClientObj);
    // console.log("selected client", selectedClient);

    //    handleSelectClient
  };

  return (
    <div className="c-page-wrapper c-page-dashboard c-page-exercises">
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav">
            <h1 className="c-header-title">Toolbox</h1>
            <ul className="c-header-nav-wrapper">
              {/* <li className={tabSelected == "TDDEE Caluclator" ? "--active" : ""} onClick={() => setTabSelected("TDDEE Caluclator")} >
                               
                                <p>TDEE & Macro Calculator<span> </span></p>
                            </li> */}
              {client_pages.map((pageTab) => {
                return (
                  <li
                    className={
                      tabSelected == pageTab.name
                        ? "c-side-client-menu-header --active"
                        : "c-side-client-menu-header"
                    }
                    onClick={() => setTabSelected(pageTab.name)}
                  >
                    <p className="c-clients-nav-link"  style={{margin:"auto"}}>{pageTab.name}</p>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="c-header-add">
            {/* <AddButton text="New Excercise" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/exercise", { update: false, from: from })} /> */}
          </div>
          <div className="c-header-logo">
            {/* <img src={logo} alt="Logo" /> */}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loader-div" >
          {/* <Loading /> */}
          <img className="loader" src={aurumLogo} />
        </div>
      ) : (
        (() => {
          if (tabSelected == "TDEE & Macro Calculator") {
            return (
              <div className="c-page-wrapper--exercises">
                <Select
                  options={options.map((data) => ({
                    
                    value: data.userID,
                    label: <div className="client-search-dropdown"><img src={data?.image} />{data.first_name + " " + data.last_name}</div> ,
                    ...data,
                  }))}
                  onChange={(e) => {
                    setSelectClient(e.label);
                    // console.log("onchange", e);
                    
                    setClientData(e);
                    setIsClientChange(!isclientChange)
                    // window.location.reload();
                  }}
                  placeholder="Select client"
                />
                <div className="c-page-main--exercises">
                  {(isclientChange&&selectClient?(
                    // <TDDEECalculator
                    //   selectedClient={clientData}
                    //   id={clientData.id}
                    // />
                    // <UpdatedTDDE
                    //   selectedClient={clientData}
                    //   id={clientData.id}
                    // />
                    <TestCalc
                      selectedClient={clientData}
                      id={clientData.id}
                    />
                    
                  ):<span></span>)}
                </div>
              </div>
            );
          } 
          else if (tabSelected == "% RM Calculator") {
            return <RepetitionMeximumCalculator />;
          }
          else if (tabSelected == "Strength Ratios") {
            return <StrengthRatioCalculator />;
          }
          
        })()
      )}
    </div>
  );
}

export default ToolBox;
